/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserLoginError {
    INVALID_CREDENTIALS = 'InvalidCredentials',
    USER_LOCKED_OUT = 'UserLockedOut',
    USER_DISABLED = 'UserDisabled',
}
